import React, { useState } from "react";
import { Dialog, IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes } from "@fortawesome/free-solid-svg-icons";

// Function to extract file extension while ignoring query parameters
const getFileExtension = (url: string): string => {
  const cleanUrl = url.split("?")[0]; // Remove query parameters
  return cleanUrl.split(".").pop()?.toLowerCase() || ""; // Extract file extension
};

// Function to check if a file is an image
const isImageFile = (url: string): boolean => {
  const extension = getFileExtension(url);
  return ["jpg", "jpeg", "png", "gif", "webp"].includes(extension);
};

interface FilePreviewProps {
  fileUrl: string;
  label: string;
}

export const FilePreview: React.FC<FilePreviewProps> = ({ fileUrl, label }) => {
  const [dialogOpen, setDialogOpen] = useState(false);

  return (
    <div className="flex flex-col gap-2">
      {isImageFile(fileUrl) ? (
        <>
          {/* Image Thumbnail */}
          <img
            src={fileUrl}
            alt={label}
            className="h-20 w-20 rounded-lg shadow-md border cursor-pointer"
            onClick={() => setDialogOpen(true)}
          />

          {/* Dialog for Fullscreen Image */}
          <Dialog open={dialogOpen} onClose={() => setDialogOpen(false)} fullScreen>
            <div className="relative flex justify-center items-center h-screen w-screen bg-black">
              {/* Close Button - ABSOLUTE POSITIONING ENSURED */}
              <IconButton
                onClick={() => setDialogOpen(false)}
                style={{
                  position: "absolute",
                  top: 20,
                  right: 20,
                  backgroundColor: "rgba(0,0,0,0.5)",
                  color: "white",
                  padding: 10,
                  borderRadius: 100,
                }}
              >
                <FontAwesomeIcon icon={faTimes} className="text-2xl" />
              </IconButton>

              {/* Enlarged Image */}
              <img
                src={fileUrl}
                alt={label}
                className="max-w-full max-h-full object-contain"
              />
            </div>
          </Dialog>
        </>
      ) : (
        // Downloadable Link for Non-Image Files
        <a
          href={fileUrl}
          target={"_blank"}
          download
          className="text-blue-500 hover:text-blue-700 font-semibold text-sm"
        >
          下載 {label}
        </a>
      )}
    </div>
  );
};
